import React from "react";
import { RenderWithFallback } from "components/shared/Conditional/RenderWithFallback";
import { StyledContainer } from "./StyledContainer";
import { QuoteAPIContainer } from "./QuoteAPIContainer";
import { QuoteConfiguration } from "./QuoteConfiguration";
import { QuoteLoadingFallback } from "./QuoteLoadingFallback";

interface Props {
  voId: string;
  onSuccess?: VoidFunction;
  onRedirect: VoidFunction;
}

export const QuoteMain = ({ onRedirect, ...props }: Props) => (
  <QuoteAPIContainer {...props}>
    {props => (
      <StyledContainer>
        <RenderWithFallback isLoading={props.isFetching} fallBack={<QuoteLoadingFallback />}>
          <QuoteConfiguration {...props} onRedirect={onRedirect} />
        </RenderWithFallback>
      </StyledContainer>
    )}
  </QuoteAPIContainer>
);
